import {
  AuthorizationPage,
  AuthorizationPagesFilter,
  AuthorizedAccount,
} from 'app/modules/settings/types/authorizedAccount';
import { PageTypeName } from 'types/Page';
import { get, httpDelete } from 'api/client';
import config from 'config';

export const AuthorizedAccountsApi = {
  getAll(): Promise<
    Record<PageTypeName, AuthorizedAccount | AuthorizedAccount[]>
  > {
    return get<Record<PageTypeName, AuthorizedAccount | AuthorizedAccount[]>>(
      `/settings/authorization`,
      {
        baseURL: config.API_SERVICE_ENDPOINT,
      },
    );
  },
  getPages(
    filter: AuthorizationPagesFilter = 'all',
  ): Promise<AuthorizationPage[]> {
    const disconnectedParam =
      filter === 'disconnected' ? 1 : filter === 'connected' ? 0 : undefined;

    return get<AuthorizationPage[]>(`/settings/authorization/pages`, {
      baseURL: config.API_SERVICE_ENDPOINT,
      params:
        disconnectedParam !== undefined
          ? { disconnected: disconnectedParam }
          : undefined,
    });
  },
  revoke(
    pageTypeName: PageTypeName | PageTypeName[],
    data?: {
      externalUserId?: AuthorizedAccount['externalUserId'];
    },
  ): Promise<PromiseSettledResult<{ message?: string }>[]> {
    const pageTypeNames = Array.isArray(pageTypeName)
      ? pageTypeName
      : [pageTypeName];

    return Promise.allSettled(
      pageTypeNames.map((pageTypeName) =>
        httpDelete<{ message?: string }>(`/api/${pageTypeName}/revoke`, {
          baseURL: config.SOCIAL_LOGIN_SERVICE_ENDPOINT,
          data: data ? data : undefined,
        }),
      ),
    );
  },
};
